import { render, staticRenderFns } from "./admin-add-new-student.vue?vue&type=template&id=3ec2b686"
import script from "./admin-add-new-student.vue?vue&type=script&lang=js"
export * from "./admin-add-new-student.vue?vue&type=script&lang=js"
import style0 from "./admin-add-new-student.vue?vue&type=style&index=0&id=3ec2b686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports